export const messages = {
  freeTrialEnded:
    'Sorry the free trial has been consumed. If you want to have more streams and more events you should upgrade the plan by adding your credit card info in the settings.',
}
